// extracted by mini-css-extract-plugin
export default {"holder_assign_kit":"assignKitToDealer_holder_assign_kit__+gm0j","customtab":"assignKitToDealer_customtab__B35fS"};